var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "errorContainer",
    { attrs: { error: _vm.erreur, warning: _vm.warning } },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("p", [_vm._v(_vm._s(this.FormMSG(1, "Action Plan")))]),
            _c("p", [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    this.FormMSG(
                      2,
                      `The carbon action plan is designed for those productions who not only want to measure their carbon footprint but actively take steps towards reducing it. Although this is an optional step for most productions, some broadcasters require you to complete an action plan so make sure to check if you're not sure. It's free to use and productions who successfully complete it are awarded a digital certification logo that can be added to your show's endboard.`
                    )
                  ) +
                  "\n\t\t\t"
              ),
            ]),
            _c("p", [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    this.FormMSG(
                      3,
                      `If you're using the albert calculator and already looking at how to reduce your footprint then you should definitely consider completing a carbon action plan so that your hard work is recognised. Albert awards productions 1,2 or 3 stars depending on both the number and type of actions they take.`
                    )
                  ) +
                  "\n\t\t\t"
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _vm.menus.length > 0
                ? _c(
                    "b-card",
                    _vm._l(_vm.menus, function (menu, i) {
                      return _c(
                        "b-row",
                        {
                          key: i,
                          class: `${
                            i === _vm.menus.length - 1
                              ? "py-3"
                              : "albert-border-bottom py-3"
                          }`,
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "py-2",
                              attrs: { cols: "12", md: "8" },
                            },
                            [
                              _c("strong", { staticClass: "text-secondary" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(menu.text) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "4" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "light", block: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleActionPlan(menu.value)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.FormMSG(41, "View / Edit")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }